module.exports = __webpack_public_path__ + "media/images/background/7-27928b8a4fd1e6bca65f9c3ac8e68bac.jpg";